//support for ms browsers
const startsWith = (str, searchString, position) => {
  position = position || 0;
  return str.substr(position, searchString.length) === searchString;
};

const authKey = "firebase:authUser:"

export function hasLocalStorageUser() {
	//console.log('hasLocalStorageUser - localStorage', localStorage)
    for (let key in localStorage) {
		//console.log('hasLocalStorageUser key', key, localStorage.getItem(key))
        if (startsWith(key, authKey)) {
            return true;
        }
    }
}

export function getLocalStorageUser() {
    //console.log('getLocalStorageUser')
    for (let key in localStorage) {
        //console.log('keys', key)
        if (startsWith(key, authKey)) {
            //console.log('getting item', key, localStorage.getItem(key))
            return localStorage.getItem(key)
        }
    }

    return undefined
}

export function setLocalStorageUser(val) {
	//console.log('setLocalStorageUser')
    for (let key in localStorage) {
	    //console.log('keys', key)
        if (startsWith(key, authKey)) {
	        //console.log('setting item', key, val)
            localStorage.setItem(key, val)
        }
    }
}

export function removeLocalStorageUser() {
    console.log('removeLocalStorageUser')
    for (let key in localStorage) {
        if (startsWith(key, authKey)) {
            console.log('removing', key)
            localStorage.removeItem(key)
        }
    }
}


// WEBPACK FOOTER //
// ./src/auth.js